import { withRouter, Link } from "react-router-dom"
import React, {useEffect, useState} from "react"
import {
    Card,
    Button,
    CardBody,
    Row,
    Col,
    UncontrolledTooltip, Badge,
} from "reactstrap"
import paginationFactory, {
    PaginationListStandalone,
    PaginationProvider,
} from "react-bootstrap-table2-paginator"
import ToolkitProvider, { Search } from "react-bootstrap-table2-toolkit"
import Select from "react-select"
import BootstrapTable from "react-bootstrap-table-next"
import { LargeModal } from "components/Common/LargeModal"
import * as moment from "moment"
import ReactHTMLTableToExcel from "react-html-table-to-excel";

function Table(props) {
    const [isOpen, setIsOpen] = useState(false)
    const [modalData, setModalsData] = useState([])
    const _renderOddName = (f, odd) => {
        if (odd?.player) {
            return odd?.player?.name;
        }
        let text = odd?.market_spec?.name ?? "";

        text = text.replaceAll("{$competitor1}", f?.competitors[0]?.name);
        text = text.replaceAll("{$competitor2}", f?.competitors[1]?.name);

        text = text.replaceAll("{total}",odd?.special_bet_value);


        return text;
    };
    let { data } = props
    useEffect(() => {
        let modalDatas= props.modelData;
        if(modalDatas){
            // console.log(modalDatas.bets)
            setModalsData(modalDatas);
        }

    }, [props.modelData]);
    data = data.sort((a, b) =>
        moment(a.created_at, "DD-MM-YYYY").isBefore(
            moment(b.created_at, "DD-MM-YYYY")
        )
            ? 1
            : -1
    )

    const columns = [
      {
        dataField: "id",
        text: "ID",
        sort: true,
      },
      {
        dataField: "pin",
        text: "PIN",
        sort: true,
        formatter: (cell, row) => <>{row.pin ?? ""}</>,
      },
      {
        dataField: "user.phone_number",
        text: "User Name",
        sort: true,
        formatter: (cell, row) => (
          <>
            {row.channel == "Online"
              ? row.user.phone_number
              : row.user.username}
          </>
        ),
      },
      {
        dataField: "channel",
        text: "Channel",
        sort: true,
        formatter: (cell, row) => <>{row.channel ?? "Online"}</>,
      },
      {
        dataField: "betType",
        text: "Bet Type",
        sort: true,
        formatter: (cell, row) => (
          <>{row.bets?.length == 1 ? "Single" : "Multiple"}</>
        ),
      },
      {
        dataField: "created_at",
        text: "Date Time",
        sort: true,
        formatter: (cell, row) => {
          const date = new Date(row?.created_at)
          const formattedDate = date.toLocaleString("en-GB", {
            timeZone: "CAT",
            hour12: true,
          })
          const capitalizedDate = formattedDate.replace(/(am|pm)/gi, match =>
            match.toUpperCase()
          )
          return <>{capitalizedDate}</>
        },
      },
      {
        dataField: "stake",
        text: "Stake",
        sort: true,
      },
      {
        dataField: "stake_after_tax",
        text: "Stake Tax",
        sort: true,
        formatter: (cell, row) => (
          <>{parseFloat(row.stake - row.stake_after_tax).toFixed(2)}</>
        ),
      },
      {
        dataField: "stake_after_tax",
        text: "Actual Stake",
        sort: true,
        formatter: (cell, row) => (
          <>{parseFloat(row.stake_after_tax).toFixed(2)}</>
        ),
      },
      // {
      //   dataField: "accept_odds_change",
      //   text: "Accept Odds Change",
      //   sort: true,
      // },
      {
        dataField: "bonus_amount",
        text: "Bonus",
        sort: true,
        formatter: (cell, row) => <>{row.bonus_amount ?? 0}</>,
      },
      {
        dataField: "wht",
        text: "WHT",
        sort: true,
        formatter: (cell, row) => <>{parseFloat(row.wht).toFixed(2)}</>,
      },
      {
        dataField: "to_win",
        text: "NetWin",
        sort: true,
        formatter: (cell, row) => <>{parseFloat(row.to_win).toFixed(2)}</>,
      },
      {
        dataField: "status",
        text: "Bet Status",
        sort: true,
        formatter: (cell, row) => (
          <>
            {row.status == 1
              ? "won"
              : row.status == 0
              ? "lost"
              : row.status == 2
              ? "void"
              : "pending"}
          </>
        ),

        // eslint-disable-next-line react/display-name
        // formatter: (cellContent, row) => (
        //   <div className="text-body fw-bold">{row.BetStatus}</div>
        // ),
      },
      // {
      //   dataField: "total_odds",
      //   text: "Total Odds",
      //   sort: true,
      // },

      // {
      //   dataField: "excise_tax",
      //   text: "Excise Tax",
      //   sort: true,
      // },

      {
        dataField: "view",
        isDummyField: true,
        text: "Action",
        sort: true,
        // eslint-disable-next-line react/display-name
        formatter: (cellContent, row) => (
          <>
            <Row>
              {/* <Col lg={5}>
              <Button type="button" color="primary" className="btn-sm">
                Refund
              </Button>
            </Col> */}
              <Col lg={5}>
                <Button type="button" color="primary" className="btn-sm">
                  Details
                </Button>
              </Col>
              {row.status == null ? (
                <Col lg={5}>
                  {new Date().getTime() <
                  new Date(
                    new Date(
                      parseInt(
                        row?.bets[0]?.odd?.fixture_market?.fixture?.match_date
                          ?.$date?.$numberLong
                      )
                    )
                  ).getTime() ? (
                    <Button
                      type="button"
                      color="danger"
                      className="btn-sm"
                      id="btn-cancel"
                      onClick={() => {
                        props.cancelTicketCall(row.id)
                      }}
                    >
                      Cancel
                    </Button>
                  ) : (
                    ""
                  )}
                </Col>
              ) : (
                ""
              )}
              <Col lg={2}></Col>
            </Row>
          </>
        ),
      },
    ]
    const modalColumns = [
        {
            dataField: "created_at",
            text: "Time",
            sort: true,
            formatter: (cell1, row1) => (
                <>{new Date(parseInt(row1.odd?.fixture_market?.fixture?.match_date?.$date?.$numberLong)).toLocaleString('en-GB')}</>
            ),
        },
        {
            dataField: "channel",
            text: "Event",
            sort: true,
            formatter: (cell1, row1) => (
                <>{row1.odd?row1.odd.fixture_market.fixture.tournament.sport.name:""}</>
            ),
        },
        {
            dataField: "is_live",
            text: "Type",
            sort: true,
            formatter: (cell1, row1) => (
                <>{row1.is_live?"Live":"Pre-Match"}</>
            ),
        },
        {
            dataField: "channel",
            text: "Fixture",
            sort: true,
            formatter: (cell1, row1) => (
                <>{row1.odd?row1.odd.fixture_market.fixture.competitors[0].name+' vs':""}  {row1.odd?row1.odd.fixture_market.fixture.competitors[1].name:""}</>
            ),
        },
        {
            dataField: "price",
            text: "Odds",
            sort: true,
            formatter: (cell1, row1) => (
                <>{parseFloat(row1?.price).toFixed(2)}</>
            ),
        },
        {
            dataField: "test",
            text: "Selection",
            sort: true,
            formatter: (cell1, row1) => (
                <>
                    {(row1?.odd?.length != 0 && row1?.odd!=null)
                        ?
                        _renderOddName(
                            row1?.odd?.fixture_market?.fixture,
                            row1?.odd
                        )
                        : ''
                    }

                </>
            ),
        },
        {
            dataField: "status",
            text: "Status",
            formatter: (cell1, row1) => (
                <>
                    <Button
                        type="button"
                        color=
                            {                   (row1?.is_cancel_by_admin) ? "info" :
                                (row1?.status == null && parseFloat(row1?.void_factor) == parseFloat(0) && row1.out_come_for_canceled==null && row1.is_won==null) ? 'info' :
                                (row1?.status) ? "success" : ((row1?.out_come_for_canceled == 'N' || row1?.out_come_for_canceled == 'C') ? "secondary" : ((parseFloat(row1?.void_factor) != parseFloat(0)) ? "primary" : ((row1?.is_won) ? "success" : "danger")))
                            }
                        className="btn-sm"
                    >
                        {
                            (row1?.is_cancel_by_admin) ? "Void" :
                            (row1?.status == null && parseFloat(row1?.void_factor) == parseFloat(0) && row1.out_come_for_canceled==null && row1.is_won==null) ? 'Pending' :

                            (row1?.status) ? "Won" : ((row1?.out_come_for_canceled == 'N' || row1?.out_come_for_canceled == 'C') ? "Cancel" : ((parseFloat(row1?.void_factor) != parseFloat(0)) ? "Void" : ((row1?.is_won) ? "Won" : "Lost")))
                        }

                    </Button>
                </>
            ),
        },
    ]
    const cardsData = [
        {
            color: "primary",
            fontColor: "text-white",
            title: "Total Stake",
            description: modalData.stake?parseFloat(modalData.stake).toFixed(2):0,
            borderClass: "",
        },
        {
            color: "success",
            fontColor: "text-white",
            title: "Effective Stake",
            description: modalData.stake_after_tax?parseFloat(modalData.stake_after_tax).toFixed(2): 0,
            borderClass: "",
        },
        {
            color: "info",
            fontColor: "text-white",
            title: "Boost",
            description: "0",
            borderClass: "",
        },
        {
            color: "warning",
            fontColor: "text-dark",
            title: "Possible Win",
            description: modalData.to_win?modalData.to_win:0,
            borderClass: "",
        },
    ]



    const defaultSorted = [
        {
            dataField: "id",
            order: "desc",
        },
    ]
    const { SearchBar } = Search
    //pagination customization

    const pageOptions = {
        sizePerPage: 10,
        totalSize: data.length,
        custom: true,
    }

    const rowEvents = {
        onClick: (e, row, rowIndex) => {
            if(e.target.id!="btn-cancel"){
                props.callById(row.id)
                setIsOpen(true);

            }
        },
    }
    return (
        <>
            <Card>
                <CardBody>
                    <div className="mb-4 h4 card-title">{"Jackpot Tickets"}</div>
                    <PaginationProvider
                        pagination={paginationFactory(pageOptions)}
                        keyField="id"
                        columns={columns}
                        data={data}
                    >
                        {({ paginationProps, paginationTableProps }) => (
                            <ToolkitProvider
                                keyField="id"
                                data={data}
                                columns={columns}
                                bootstrap4
                                search
                            >
                                {toolkitProps => (
                                    <React.Fragment>
                                        <Row className="mb-2">
                                            <Col sm="6">
                                                <Row>
                                                    <Col sm="6">
                                                        <div className="search-box me-2 mb-2 d-inline-block">
                                                            <div className="position-relative">
                                                                <SearchBar {...toolkitProps.searchProps} />
                                                                <i className="bx bx-search-alt search-icon" />
                                                            </div>
                                                        </div>
                                                    </Col>
                                                    <Col sm="6">
                                                        <div>
                                                            <ReactHTMLTableToExcel
                                                                id="test-table-xls-button"
                                                                className="download-table-xls-button w-md btn btn-primary"
                                                                table="table-to-xls"
                                                                filename={`Jackpot-Tickets-Bets-Report-${moment(new Date()).format("DD/MM/YYYY")}`}
                                                                sheet="tablexls"
                                                                buttonText="Download"
                                                                type="button"
                                                            />
                                                        </div>
                                                    </Col>
                                                </Row>
                                            </Col>
                                            <Col sm={6}></Col>
                                        </Row>
                                        <Row>
                                            <Col xl="12">
                                                <div className="table-responsive">
                                                    <BootstrapTable id="table-to-xls"
                                                                    keyField="id"
                                                                    responsive
                                                                    bordered={false}
                                                                    striped={false}
                                                                    defaultSorted={defaultSorted}
                                                        //   selectRow={selectRow}
                                                                    classes={
                                                                        "table align-middle table-nowrap table-check"
                                                                    }
                                                                    headerWrapperClasses={"table-light"}
                                                                    {...toolkitProps.baseProps}
                                                                    {...paginationTableProps}
                                                                    rowClasses={"mytable-hover-row"}
                                                                    rowEvents={rowEvents}
                                                    />
                                                </div>
                                            </Col>
                                        </Row>
                                        <div className="pagination pagination-rounded justify-content-end">
                                            <PaginationListStandalone {...paginationProps} />
                                        </div>
                                    </React.Fragment>
                                )}
                            </ToolkitProvider>
                        )}
                    </PaginationProvider>
                </CardBody>
            </Card>

            {
                (Object.keys(modalData).length !== 0) ?
                    <LargeModal
                        isOpen={isOpen}
                        setIsOpen={setIsOpen}
                        cardsData={cardsData}
                        betType={"1bet, 2-fold multiple"}
                        size={"xl"}
                        columns={modalColumns}
                        data={modalData}
                    />
                    : ''
            }

        </>
    )
}

export default Table
